import React from 'react';
import './timeline.css'
import { Chrono } from "react-chrono";

const App = () => {
    const events = [
        {
            title: "15th August 2023, 9 AM ",
            cardTitle: "Team Registration & Idea Submission Commences",
        },
        {
            title: '18th August 2023, 11:59 PM',
            cardTitle: 'Idea Submission Deadline',
        },
        {
            title: '19th August, 12 noon',
            cardTitle: 'Shortlisted Teams Announcement',
        },
        {
            title: "23rd August 2023, 11 AM",
            cardTitle: "Grand Finale Event",
        },
        {
            title: "23rd August 2023, 4 PM ",
            cardTitle: "Valedictory & Prize Distribution",
        },
    ];

    return (
        <div className="timeline">
            <p className='Title'>TIMELINE</p>
            <div style={{ width: "70%", height: "max-content" }}>
                <Chrono
                    items={events}
                    mode="VERTICAL"
                    cardHeight={20}
                    slideShow
                    theme={{
                        primary: 'white',
                        secondary: 'greenyellow',
                        cardBgColor: '#171717',
                        titleColor: 'greenyellow',
                        titleColorActive: '#171717',
                    }}
                    fontSizes={{
                        cardText: '140%',
                        cardTitle: '140%',
                        title: '140%',
                    }}
                />
            </div>
        </div>
    );
};

export default App;
